import styled, { keyframes, css } from "styled-components";
import global from "../../global";

export const HeaderActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    flex-direction: column;
    
    & > * {
      width: 100% !important;
      flex-shrink: 0;
    }

    & > button, 
    & > div > button {
      width: 100% !important;
      justify-content: center;
    }
  }
`;

export const SearchSelectWrapper = styled.div`
  position: relative;
  height: 38px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  z-index: 1;
  width: 130px;
  flex-shrink: 0;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
  }
`;

export const SearchSelectButton = styled.button`
  height: 38px;
  width: 130px;
  padding: 0 16px;
  border: 1px solid var(--fixit);
  border-radius: 20px;
  background-color: transparent;
  color: var(--fixit);
  font-size: 14px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  svg {
    pointer-events: none;
    color: var(--fixit);
    width: 16px;
    height: 16px;
    stroke-width: 2.5px;
  }

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
  }
`;

export const SearchContainer = styled.form`
  display: flex;
  width: 350px; 
  height: 38px;
  box-sizing: border-box;
  position: relative; /* Para posicionamento absoluto das sugestões */

  /* Força união perfeita entre o Select e o Input */
  ${SearchSelectWrapper} + input {
    border-radius: 0 !important;
    border-left: none !important;
    margin-left: -20px !important;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    width: 100% !important;
    min-width: unset;
    height: 38px !important;
    min-height: 38px !important;
    flex-shrink: 0;
  }
`;

export const SearchInput = styled.input<{ $hasText?: boolean }>`
  flex: 1;
  height: 38px;
  padding: 0 52px 0 16px;
  background: transparent;
  border: 1px solid ${({ $hasText }) => ($hasText ? "var(--fixit)" : "var(--light-gray)")};
  border-right: none;
  border-radius: 20px 0 0 20px;
  font-size: 14px;
  color: var(--title);
  outline: none;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  margin-right: -20px;
  min-width: 0;

  &::placeholder {
    color: var(--gray);
  }

  &:focus {
    border-color: var(--fixit);
    z-index: 2;
    position: relative;
  }

  /* When preceded by select wrapper, overlap both sides */
  ${SearchSelectWrapper} + & {
    border-radius: 0;
    border-left: none;
    margin-left: -20px;
    padding-left: 28px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
  }
`;

export const ClearSearchButton = styled.button<{ $hasSelect?: boolean; $onRight?: boolean }>`
  position: absolute;
  left: ${({ $hasSelect, $onRight }) => ($onRight ? "auto" : $hasSelect ? "138px" : "12px")};
  right: ${({ $onRight }) => ($onRight ? "50px" : "auto")};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--gray);
  cursor: pointer;
  z-index: 3;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    color: var(--fixit);
    background-color: rgba(152, 53, 209, 0.1);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const SelectedFilterBadge = styled.div`
  flex: 1;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 44px 0 16px;
  background: transparent;
  border: 1px solid var(--light-gray);
  border-right: none;
  box-sizing: border-box;
  margin-right: -20px;
  min-width: 0;
  cursor: default;

  ${SearchSelectWrapper} + & {
    border-radius: 0;
    border-left: none;
    margin-left: -20px;
    padding-left: 28px;
  }
`;

export const SelectedFilterTag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(152, 53, 209, 0.08);
  border: 1px solid rgba(152, 53, 209, 0.2);
  color: var(--fixit);
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: var(--fixit);
    cursor: pointer;
    padding: 0;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    transition: background 0.2s;

    &:hover {
      background-color: rgba(152, 53, 209, 0.15);
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const SearchButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 38px;
  background: transparent;
  border: 1px solid var(--fixit);
  border-radius: 20px;
  color: var(--fixit);
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
  margin-left: -20px;
  z-index: 4;
  position: relative;
  flex-shrink: 0;

  ${({ $disabled }) => $disabled && css`
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  `}

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }
  
  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
    width: 60px !important;
    min-width: 60px;
  }
`;

export const SearchSuggestionsList = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  margin: 0;
  list-style: none;
  z-index: 100;
  overflow: hidden;
`;

export const SearchSuggestionItem = styled.li`
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--title);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background-color: rgba(152, 53, 209, 0.05);
    color: var(--fixit);
  }
`;

const urgencyChoreography = keyframes`
  /* 0% a 10%: Círculo compacto estático e centralizado */
  0%, 10% {
    max-width: 20px;
    padding: 1px 4px;
    transform: scale(1) translateX(0) rotate(0deg);
  }
  /* 11% a 19%: Vibração de alerta rápida na BOLINHA INTEIRA */
  11% { transform: scale(1) translateX(-2px) rotate(-10deg); }
  13% { transform: scale(1.05) translateX(2px) rotate(10deg); }
  15% { transform: scale(1.1) translateX(-2px) rotate(-15deg); }
  17% { transform: scale(1.1) translateX(2px) rotate(15deg); }
  19% { transform: scale(1.05) translateX(-1px) rotate(-10deg); }
  /* 20%: Retorno ao estado inicial */
  20% {
    max-width: 20px;
    padding: 1px 4px;
    transform: scale(1) translateX(0) rotate(0deg);
  }
  /* 20% a 30%: Expansão unilateral suave apenas para a direita */
  30%, 75% {
    max-width: 80px;
    padding: 1px 6px 1px 4px;
    transform: scale(1) translateX(0) rotate(0deg);
  }
  /* 75% a 85%: Retração lateral perfeita com ícone estável */
  85%, 100% {
    max-width: 20px;
    padding: 1px 4px;
    transform: scale(1) translateX(0) rotate(0deg);
  }
`;

const smoothTextReveal = keyframes`
  /* 0% a 20%: Texto colapsado e invisível */
  0%, 20% {
    opacity: 0;
    visibility: hidden;
    transform: translateX(-4px);
    margin-left: 0;
    max-width: 0;
  }
  /* 30% a 75%: Texto 100% aberto e legível */
  30%, 75% {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
    margin-left: 4px;
    max-width: 50px;
  }
  /* 85% a 100%: Retorna a colapsar em perfeito sincronismo */
  85%, 100% {
    opacity: 0;
    visibility: hidden;
    transform: translateX(-4px);
    margin-left: 0;
    max-width: 0;
  }
`;

export const UrgencyBadge = styled.span`
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.2);
  font-size: 10px;
  font-weight: 700;
  border-radius: 12px;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  height: 18px;
  min-width: 20px;
  margin-left: 4px;
  line-height: 1;

  animation: ${urgencyChoreography} 6s infinite ease-in-out;

  svg {
    min-width: 10px;
    transform-origin: center center;
  }

  .badge-text {
    animation: ${smoothTextReveal} 6s infinite ease-in-out;
    overflow: hidden;
  }
`;

const radarRipple = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.55;
  }
  100% {
    transform: scale(2.8);
    opacity: 0;
  }
`;

export const StatusBolinha = styled.div<{ color: string; shouldPulse?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.color};
  position: relative;
  z-index: 1;
  transition: all 0.2s ease;

  ${props => props.shouldPulse && css`
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: inherit;
      animation: ${radarRipple} 1.6s infinite cubic-bezier(0.25, 0.46, 0.45, 0.94);
      z-index: -1;
    }
  `}
`;

interface ITotalProps {
  isOpen?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Header = styled.div`
  width: 100%;
  margin-top: 10px;
  gap: 10px;

  display: flex;
  align-items: end;
  justify-content: space-between;

  .title {
    color: var(--dark-gray);
    font-size: 30px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    flex-direction: column-reverse;
    margin-top: 0px;
    gap: 10px;
  }
`;

export const FixiterActionsText = styled.span`
  text-align: center;
  font-weight: 500;
  color: var(--fixit);
  font-size: 20px;
  margin-bottom: 10px;
`;

export const FixiterCardName = styled.span`
  font-size: 16px;
  color: var(--dark-gray);
  margin-bottom: 5px;

  label {
    color: black;
    margin-left: 5px;
  }

  :hover {
    cursor: pointer;
  }
`;

export const CardsContainer = styled.div`
  margin-top: 50px;
  display: flex;
  align-items: center;
  gap: 50px;
`;

export const ListContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 26px;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    gap: 10px;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
`;

export const LoadMore = styled.div`
  color: var(--gray);
  padding: 5px 18px;
  cursor: pointer;
  border: 1px solid var(--gray);
  border-radius: 15px;
  font-size: 14px;
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    width: 100%;
    margin-left: 0px;
    justify-content: end;
    gap: 10px;
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    margin-right: 0px;
  }
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 11px 8px 14px;
  border-radius: 25px;
  background: #eae8e8;
  background: var(--white);
  border: 1px solid var(--gray);

  span {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: var(--gray);
  }

  svg {
    margin-left: 2px;
    cursor: pointer;
    color: var(--gray);
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    padding: 5px 9px 5px 10px;

    span {
      font-size: 12px;
      line-height: 12px;
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

export const FilterContainer = styled.div`
  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
  }
`;

export const OrderInfosContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;

  .price_info {
    display: flex;
    align-items: center;
    gap: 2px;

    p {
      font-weight: 500;
    }
  }
`;

export const PopupContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  color: var(--dark-gray);

  .timer {
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 0px;
    margin-bottom: 10px;
    line-height: 0;
    border: 2px solid var(--printed);
    border-radius: 25px;
    color: var(--printed);
    padding: 20px 15px;
  }

  svg {
    color: var(--fixit);
  }

  h1 {
    font-size: 1.6rem;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 1.4rem;
    margin-right: auto;
  }

  ul {
    font-size: 1.1rem;
    padding: 8px 8px 8px 0;
    list-style-type: none;
    width: 100%;

    span {
      font-weight: 500;
      margin-right: 12px;
    }

    li {
      margin-bottom: 4px;
      display: flex;
      width: 100%;
    }
  }

  a {
    font-size: 1.2rem;
    color: var(--fixit);
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 32px;
    line-height: 0;
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 12px;
`;

export const FilamentConfigText = styled.h1`
  font-size: 8px;
  font-weight: 500;

  color: var(--fixit);
`;

export const Section = styled.section`
  h2 {
    color: var(--dark-gray);
    padding-bottom: 12px;
  }

  padding: 20px;
  min-width: 300px;
  width: calc(50% - 30px);

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    margin-right: 0;
  }

  .filament_config {
    font-size: 12px;
    color: var(--dark-gray);
    margin-top: 20px;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--dark-gray);
  padding-top: 6px;
  font-size: 12px;
`;

export const DataBar = styled.div`
  display: flex;
  gap: 5px;
  justify-content: space-around;
`;

export const TotalInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  min-width: 50px;

  .label {
    font-size: 10px;
    line-height: 15px;
    color: var(--gray);
    font-weight: 500;
  }

  .value {
    font-size: 14px;
    line-height: 10px;
    color: var(--active-green);
    margin-top: 6px;
    font-weight: bolder;
  }

  /* .value_discounted {
    font-size: 14px;
    line-height: 10px;
    color: var(--error);
    margin-top: 6px;
    font-weight: bolder;
  } */
`;

export const TotalContainer = styled.div`
  display: flex;
  gap: 12px;
  border-radius: 14px;
  padding: 16px 26px 16px 28px;
  background: var(--white);
  box-shadow: 1px 5px 10px rgb(0 0 0 / 25%);

  .StandardTotalInfo {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    width: 100%;
    flex-direction: column;
    padding: 16px 20px 16px 22px;

    .StandardTotalInfo {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
`;

export const TotalDescription = styled.div<ITotalProps>`
  ${(props) => (props.isOpen ? `display: flex;` : `display: none;`)}
  flex-direction: row;
  gap: 12px;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    justify-content: flex-end;
  }
`;

export const ArrowIcon = styled.div<ITotalProps>`
  display: flex;
  cursor: pointer;
  align-items: flex-end;

  .RightArrow {
    ${(props) => (props.isOpen ? `display: none;` : `display: flex;`)}
    @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
      display: none;
    }
  }

  .LeftArrow {
    ${(props) => (props.isOpen ? `display: flex;` : `display: none;`)}
    @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
      display: none;
    }
  }

  .UpArrow {
    ${(props) => (props.isOpen ? `display: flex;` : `display: none;`)}
    @media (min-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
      display: none;
    }
  }

  .DownArrow {
    ${(props) => (props.isOpen ? `display: none;` : `display: flex;`)}
    @media (min-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
      display: none;
    }
  }
`;

export const TotalMobileView = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    gap: 1rem;
  }
`;

export const SwitchBackground = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #fff;
  height: 20px;
  width: 20px;
  border: 1px solid var(--light-gray);
`;

export const ProductionQueueSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

interface ProductionQueueWrapperProps {
  isActive: boolean;
}

export const ProductionQueueWrapper = styled.div<ProductionQueueWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 12px; /* Espaçamento unificado de 12px entre o cabeçalho e a tabela da fila */
  width: 100%;
  background-color: ${({ isActive }) => (isActive ? "rgba(152, 53, 209, 0.04)" : "var(--white)")};
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: ${({ isActive }) => (isActive ? "12px 16px 16px 16px" : "12px 16px")};
  transition: all 0.2s ease;
  cursor: pointer;

  /* Sobrescreve o min-height de 220px padrão das tabelas para se ajustar perfeitamente ao número de itens */
  & > div {
    min-height: auto;
  }

  &:hover {
    transform: ${({ isActive }) => (isActive ? "none" : "translateY(-2px)")};
    box-shadow: ${({ isActive }) => (isActive ? "0px 4px 12px rgba(0, 0, 0, 0.03)" : "0px 8px 20px rgba(0, 0, 0, 0.06)")};
    
    .queue-title {
      color: var(--fixit);

      svg {
        color: var(--fixit);
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    border-radius: 16px;
    padding: ${({ isActive }) => (isActive ? "10px 12px 12px 12px" : "10px 12px")};
  }
`;

interface ProductionQueueContainerProps {
  isActive: boolean;
}

export const ProductionQueueContainer = styled.div<ProductionQueueContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
  padding: 0;
  width: 100%;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
`;

interface ProductionQueueTitleProps {
  isActive: boolean;
}

export const ProductionQueueTitle = styled.div<ProductionQueueTitleProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ isActive }) => (isActive ? "var(--fixit)" : "var(--gray)")};
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: ${({ isActive }) => (isActive ? "600" : "500")};
  letter-spacing: -0.01em;
  transition: color 0.2s, font-weight 0.2s;

  svg {
    transition: transform 0.2s ease, color 0.2s ease;
    color: ${({ isActive }) => (isActive ? "var(--fixit)" : "var(--gray)")};
  }
`;

export const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface RightControlsWrapperProps {
  isActive?: boolean;
}

export const RightControlsWrapper = styled.div<RightControlsWrapperProps>`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const UrgentPriorityBadge = styled.span`
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.2);
  font-size: 10px;
  font-weight: 700;
  border-radius: 12px;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  height: 18px;
  padding: 1px 6px 1px 4px;
  margin-left: 4px;
  line-height: 1;

  svg {
    min-width: 10px;
    transform-origin: center center;
  }

  .badge-text {
    margin-left: 4px;
  }
`;

export const QueueCountBadge = styled.span`
  background: rgba(152, 53, 209, 0.12);
  color: var(--fixit);
  border: 1px solid rgba(152, 53, 209, 0.2);
  font-size: 10px;
  font-weight: 700;
  border-radius: 12px;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  height: 18px;
  padding: 1px 6px;
  margin-left: 4px;
  line-height: 1;
`;

export const EmptyQueueMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: var(--gray);
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  background: transparent;
`;


